import React from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import { ConfigProvider } from 'antd'
// import enGB from "antd/lib/locale-provider/en_GB";
import enGB from 'antd/locale/en_GB'
import { history } from '../_helpers'
import { alertActions } from '../_actions'
import { PrivateRoute } from '../_components'
import { HomePage } from '../HomePage'
import { LoginPage } from '../LoginPage'
import { RegisterPage } from '../RegisterPage'
import tokenService from '../_services/tokenService'

import 'primereact/resources/themes/nova/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import './app.css'

class App extends React.Component {
    constructor(props) {
        super(props)

        const { dispatch } = this.props
        history.listen((location, action) => {
            // clear alert on location change
            dispatch(alertActions.clear())
        })
    }

    async componentDidMount() {
        // Initialize token service
        try {
            console.log('🔄 App: Initializing token service...')
            await tokenService.initialize()

            // Listen for postMessage from parent window
            const messageHandler = event => {
                // 🔒 SECURITY: Always check the origin first!
                const allowedOrigins = [
                    'http://localhost', // ASP.NET dev server (various ports)
                    'https://localhost', // ASP.NET dev server HTTPS
                    'http://127.0.0.1', // Alternative localhost
                    'https://127.0.0.1', // Alternative localhost HTTPS
                    'https://calendar.crystalpayroll.co.nz',
                    'https://secure.crystalpayroll.co.nz',
                    'https://crystalpayroll.co.nz'
                    // Add your production domains here:
                    // 'https://yourdomain.com',
                    // 'https://app.yourdomain.com'
                ]

                // Check if the origin is allowed (flexible matching for localhost with any port)
                const isOriginAllowed = allowedOrigins.some(allowedOrigin => {
                    if (
                        allowedOrigin.includes('localhost') ||
                        allowedOrigin.includes('127.0.0.1')
                    ) {
                        // For localhost, allow any port
                        const originBase = event.origin
                            .split(':')
                            .slice(0, 2)
                            .join(':') // http://localhost or https://localhost
                        const allowedBase = allowedOrigin
                            .split(':')
                            .slice(0, 2)
                            .join(':')
                        return originBase === allowedBase
                    }
                    return event.origin === allowedOrigin
                })

                if (!isOriginAllowed) {
                    console.warn(
                        '🚫 App: Message from unauthorized origin:',
                        event.origin
                    )
                    console.warn('🚫 Allowed origins:', allowedOrigins)
                    return // Reject the message
                }

                console.log(
                    '📨 App: Received message from authorized origin:',
                    event.origin,
                    event.data
                )

                if (event.data && event.data.type === 'API_TOKEN') {
                    console.log(
                        '✅ App: API token received via postMessage from:',
                        event.origin
                    )
                    tokenService.setToken(
                        event.data.token,
                        `postMessage:${event.origin}`
                    )
                }
            }

            window.addEventListener('message', messageHandler)

            // Request token from parent if we're in an iframe
            if (window.parent !== window) {
                console.log('📤 App: Requesting token from parent window...')
                window.parent.postMessage(
                    {
                        type: 'REQUEST_TOKEN',
                        source: 'React_App',
                        timestamp: Date.now(),
                    },
                    '*'
                )
            }

            // Store the message handler for cleanup
            this.messageHandler = messageHandler
        } catch (error) {
            console.error('App: Token initialization error:', error)
        }
    }

    componentWillUnmount() {
        // Cleanup message listener
        if (this.messageHandler) {
            window.removeEventListener('message', this.messageHandler)
        }
    }

    render() {
        const { alert } = this.props
        return (
            <ConfigProvider locale={enGB}>
                <div>
                    <div className="app">
                        <HomePage />
                    </div>
                </div>
            </ConfigProvider>
        )
    }
}

function mapStateToProps(state) {
    const { alert } = state
    return {
        alert,
    }
}

const connectedApp = connect(mapStateToProps)(App)
export { connectedApp as App }
